import { SearchResult } from 'types';

export const isSearchResultType = (
  type: string | keyof SearchResult,
  searchResults: SearchResult
): type is keyof SearchResult => Object.hasOwn(searchResults, type);
